import { Logger } from '@/helpers/log';
import { ns } from '@/helpers/store';
import { DASHBOARD_WIDGETS } from '@/store/types/getters';
import { WIDGETS } from '@/store/types/namespaces';

const logger = new Logger('store:amplify:dashboards/currentDashboard');

export default function currentDashboard(state, getters, rootState, rootGetters) {
  const { dashboard, filter } = state;
  if (!dashboard) {
    return null;
  }
  const {
    id: did,
    name,
    sliceProperty,
    widgets: pointers = [],
  } = dashboard;
  const widgets = rootGetters[ns(WIDGETS, DASHBOARD_WIDGETS)];
  const filters = rootState?.filters?.filters;
  const savedFilter = dashboard.filter || filter;
  let scopeFilter = null;
  if (filters && savedFilter) {
    scopeFilter = filters.find(({ id }) => id === savedFilter || id === savedFilter?.id);
  }

  let linked = [];
  if (Array.isArray(pointers)) {
    linked = pointers.map((pointer) => {
      const { id: wid, ...position } = pointer;
      const props = widgets[wid];
      if (!props) {
        logger.error('dashboard references missing widget', wid);
        return { ...position };
      }
      return { id: wid, ...props, ...position };
    });
  }

  return {
    id: did,
    name,
    sliceProperty,
    filter: scopeFilter,
    widgets: linked,
  };
}
